/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { uniq } from "lodash";

import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";

import { Collapse } from "antd";

import CreateSelectForm from "../../components/Form/CreateSelectForm";

import SelectFormItem from "../../components/FormItem/SelectFormItem";
import DetailPermissionForm from "../../components/Form/PermissionForm/DetailPermissionForm";
import UserIndexPermission from "../../components/UserPermission/UserIndexPermission";
import UserProjectPermission from "../../components/UserPermission/UserProjectPermission";
//utils
import {
  updateSendValuesHandler,
  setInitialValueCustomPermission,
  setInitialValueRoles,
  detailFormSetFields,
} from "../../components/UserPermission/Utils/Utils";

import { getmanagementGroupIndexes } from "../../components/UserPermission/Utils/getManagementGroupIndex"
import { rolesGetUserRoleData } from "../../api/role";

const { Panel } = Collapse;

class UserPermission extends Component {
  state = {
    loading: false,
    visible: false,
    userId: '',
    select: null,
    fromData: null,
    disabledState: true,
    indexList: [],
    indexPermissions: {},
    indexEnabled: false,
    not_allowed_project_list: [],
    endUserAccess:false
  };

  async componentDidMount() {
    await this.props.userListGet();
  }

  formOneSaveFormRef = (formRef) => {
    this.formOneFormRef = formRef;
  };
  formTwoSaveFormRef = (formRef) => {
    this.formTwoFormRef = formRef;
  };

  set_not_allowed_project_list = (id, val) => {
    let list = this.state.not_allowed_project_list;
    if (!val) {
      list.push(id);
      list = uniq(list);
    } else {
      list = list.filter((el) => el !== id);
    }
    this.setState({
      not_allowed_project_list: list,
    });
  };

  formTwoSubmit = async (values) => {
    let sendValues = await updateSendValuesHandler(values);

    sendValues.custom_permission_data.index_permissions = {
      index_permission_access: this.state.indexEnabled === true,
      permission_list:
        this.state.indexEnabled === true ? this.generateIndexPermission() : [],
    };
    sendValues.custom_permission_data.project_permissions = {
      not_allowed_project_list: this.state.not_allowed_project_list,
    };
    const customPermissionWithHotelIds = { ...this.state.select }
    delete customPermissionWithHotelIds['hotels_ids'];
    delete customPermissionWithHotelIds['hotels']
    sendValues = { ...customPermissionWithHotelIds, ...sendValues }

    if (await this.props.userUpdate(sendValues)) {
   //   await this.props.userGet();
    }
  };

  setIndexEnabled = (value) => {
    let permissions = { ...this.state.indexPermissions };
    if (value !== true) {
      Object.keys(permissions).forEach((elm) => {
        permissions[elm] = false;
      });
    }
    this.setState({
      indexEnabled: value === true,
      indexPermissions: permissions,
    });
  };

  generateIndexPermission = () => {
    let permissionList = [];

    Object.keys(this.state.indexPermissions).forEach((rlm) => {
      const keysplit = rlm.split("_");

      permissionList.push({
        hmg_id: keysplit[1],
        index_id: keysplit[2],
        value: this.state.indexPermissions[rlm],
      });
    });
    return permissionList;
  };

  setIndexPermissions = (key, val) => {
    let indexperm = { ...this.state.indexPermissions };
    if (indexperm[key] !== undefined) {
      indexperm[key] = val;
    }
    this.setState({ indexPermissions: indexperm });
  };

  defaultPermissionOnChange = (checked) => {
    this.setState({ disabledState: checked });
  };

  foremOneUserNameOnChange = async (id) => {
    const data = { user_id: id }
    const userById = await this.props.userGetById(data);
    const userData = userById?.data[0];
    if (userData?.status) {
      this.setState({ select: userData });
      this.setFormTwoValues(userData);
    }else if(this.formTwoFormRef){
      this.formTwoFormRef.resetFields()
      this.setState({select:''})
    }
  };
  selectOneChange = (id) => {
    this.setState({ userId: id })
    this.foremOneUserNameOnChange(id);
  };

  setFormTwoValues = async (value) => {
    const roledataresponse = await rolesGetUserRoleData(value.role_id);
    // console.log(roledataresponse,'role data response')
    // await this.props.rolesGet(value.role_id);

    // const result = this.props.api.rolesGetData.data.find(
    //   (e) => e._id === value.role_id,
    // );
    const result = roledataresponse.data;
    if (value.custom_permission) {
      setInitialValueCustomPermission(value);
      const userindxreslt = getmanagementGroupIndexes(value);

      this.setState({
        disabledState: false,
        not_allowed_project_list: userindxreslt.not_allowed_project_list,
        indexList: userindxreslt.indexList,
        indexPermissions: userindxreslt.indexPermissions,
        indexEnabled: userindxreslt.indexEnabled,
      });
    } else {
      setInitialValueRoles(result);
      const roleindxreslt = getmanagementGroupIndexes(
        value,
        "role",
        result,
      );
      this.setState({
        disabledState: true,
        not_allowed_project_list: roleindxreslt.not_allowed_project_list,
        indexList: roleindxreslt.indexList,
        indexPermissions: roleindxreslt.indexPermissions,
        indexEnabled: roleindxreslt.indexEnabled,
      });
    }
    const userAccess= detailFormSetFields(value, this.state.select, this.formTwoFormRef);
    this.setState({endUserAccess:userAccess})
  };
  formOnFinish = async (values) => {
    if (this.state.create) {
      if (await this.props.roleCreate(values)) {
        this.formOneFormRef.resetFields();
        this.customFormRest();
        await this.props.rolesGet();
      }
    }
  };

  formOnFinshFailed = (errInfo) => {
    if (errInfo) {
      return;
    }
  };

  indexPermissionHandler = (data) => {
    this.setState({
      indexEnabled: data.isEnabled,
      indexPermissions: data.indexPermissions,
    })
  }
  hmgPermissionUpdate = (data) => {
    this.setState({ indexPermissions: data })
  }

  render() {
    const formItem = {
      label: "User",
      name: "user_name",
      message: "Please Select a User",
    };
    const selectChange = { selectOneChange: this.selectOneChange };
    const additionalParameters = {
      indexEnabled: this.state.indexEnabled,
      setIndexEnabled: this.setIndexEnabled,
      not_allowed_project_list: this.state.not_allowed_project_list,
      set_not_allowed_project_list: this.set_not_allowed_project_list,
    };

    let isAdmin = this.props?.api?.permission?.sm_solution_access ?? false;
    return (
      <div>
        <div className="container_ab">
          <div className="container_style_2">
            <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
              <Panel header="User Permission" key="1_1" arrow="right">
                <div className="is_form_1">
                  {this.props.api.userListGetData && (
                    <CreateSelectForm
                      formItem={formItem}
                      onFinishFailed={this.formOnFinshFailed}
                      onFinish={this.formOnFinish}
                      formData={this.formOneSaveFormRef}
                      isUserPermission={true}
                    >
                      <SelectFormItem
                        formItem={formItem}
                        selectData={this.props.api.userListGetData.data}
                        selectChange={selectChange}
                        placeholder="Select a User"
                      />
                    </CreateSelectForm>
                  )}
                </div>
              </Panel>
            </Collapse>

            <div style={{ marginBottom: 20 }}></div>

            {this.state.select ? (
              <DetailPermissionForm
                onFinish={this.formTwoSubmit}
                onFinishFailed={this.formOnFinshFailed}
                isUserPermission={true}
                select={this.state.select}
                formData={this.formTwoSaveFormRef}
                disabledState={this.state.disabledState}
                defaultPermissionOnChange={this.defaultPermissionOnChange}
                isAdmin={isAdmin}
              >
                {this.state.indexList.length > 0 && (
                  <>  
                     <UserProjectPermission
                      disabledState={this.state.disabledState}
                      indexList={this.state.indexList}
                      additionalParameters={additionalParameters}
                    />
                    <UserIndexPermission
                      disabledState={this.state.disabledState}
                      indexPermissions={this.state.indexPermissions}
                      setIndexPermissions={this.setIndexPermissions}
                      indexList={this.state.indexList}
                      additionalParameters={additionalParameters}
                      indexPermissionHandler={this.indexPermissionHandler}
                      hmgPermissionUpdate={this.hmgPermissionUpdate}
                    />
                  </>
                )}
              </DetailPermissionForm>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const WrappedApp = Form.create({ name: "coordinated" })(UserPermission);

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  rolesGet: (data) => dispatch(actions.rolesGet(data)),
  userListGet: () => dispatch(actions.userListGet()),
  roleCreate: (data) => dispatch(actions.roleCreate(data)),
  roleUpdate: (data) => dispatch(actions.roleUpdate(data)),
  userGet: () => dispatch(actions.userGet()),
  userGetById: (data) => dispatch(actions.userGetById(data)),
  userUpdate: (data) => dispatch(actions.userUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WrappedApp);